<template>
    <div>
        <b-navbar type="dark" class="background-gradient">
            <b-navbar-brand :to="{name: 'home'}">
                <img class="login-logo" src="@/assets/logo_hemocir_white.svg" alt="">
            </b-navbar-brand>

            <b-navbar-nav v-if="isAuthenticated" class="ml-auto">
                <b-nav-item :to="{name: 'home'}" active-class="active" exact>
                    {{ $tc('sidebar.home') }}
                </b-nav-item>
                <b-nav-item :to="{name: 'patients'}" active-class="active" exact>
                    {{ $tc('sidebar.patients') }}
                </b-nav-item>
                <b-nav-item :to="{name: 'patient-add'}" active-class="active" exact>
                    {{ $tc('patient.addPatient') }}
                </b-nav-item>
                <b-nav-item :to="{name: 'documentation'}" active-class="active" exact>
                    {{ $tc('sidebar.documentation') }}
                </b-nav-item>
               <b-nav-item v-if="isAdmin" :href="adminUrl" active-class="active" exact>
                    {{ $tc('sidebar.adminPanel') }}
               </b-nav-item>

                <b-nav-text class="mx-3">|</b-nav-text>

                <b-nav-item-dropdown right>
                    <template v-slot:button-content>
                        {{ getUserName }}<i class="fas fa-user-circle ml-3" style="font-size: 1.2rem"></i>
                    </template>
                    <b-dropdown-item :to="{name: 'password-change'}">
                        {{ $t('passwordchange.title') }}
                    </b-dropdown-item>
                    <b-dropdown-item :to="{name: 'contact'}">
                        {{ $t('footer.contact') }}
                    </b-dropdown-item>
                    <b-dropdown-item href="#" @click="logout">{{ $tc('sidebar.logout') }}</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "TheHeader",
        props: {
            isAuthenticated: {
                type: Boolean,
                default: true
            },
        },
        computed: {
            ...mapGetters([
                'getUserName',
                'isAdmin'
            ]),
            adminUrl() {
              return process.env.VUE_APP_SERVERURL + "admin/";
            },
        },
        methods: {
            logout() {
                location.replace(process.env.VUE_APP_SERVERURL + 'api-auth/logout/');
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    .login-logo {
        width: auto;
        height: 30px;
    }
    i.fa-user-circle {
        font-size: 1.5rem;
        color: white;
    }
    .navbar-dark .navbar-text {
        color: white;
    }

    .background-gradient {
        background-image: linear-gradient(to right, $secondary , $primary);
    }

</style>